/**
 * 公司
 */
export let COMPANY_OPTIONS: any = {"HQ": "华强", "JR": "嘉锐"};

export let COMPANY_LIST = [
    {name: "华强", desc: "华强", id: "HQ", value: "HQ"},
    {name: "嘉锐", desc: "嘉锐", id: "JR", value: "JR"}
];

export const CHANGE_COMPANY_OPTIONS = (receiptType: string) => {
    if (receiptType == 'HQ') {
        COMPANY_OPTIONS = {"HQ": "华强"};
        COMPANY_LIST = [
            {name: "华强", desc: "华强", id: "HQ", value: "HQ"}
        ];
    }
    if (receiptType == 'JR') {
        COMPANY_OPTIONS = {"JR": "嘉锐"};
        COMPANY_LIST = [
            {name: "嘉锐", desc: "嘉锐", id: "JR", value: "JR"}
        ];
    }
}

/**
 * 成交方式
 */
export const INTERNATIONAL_TRADE_TERMS = () =>
    [
        {label: "FOB", id: "1"},
        {label: "CIF", id: "2"},
        {label: "C&F", id: "3"},
        {label: "DPU", id: "4"}
    ];


/**
 * 付款方式
 */

export const PAYMENT_TYPE = () => [
    {label: "定金", id: "1"},
    {label: "赊账付款(OA)", id: "2"},
    {label: "信用证(L/C)", id: "3"},
    {label: "付款交单(DP)", id: "4"},
    {label: "发货前付款", id: "5"},
    {label: "见提单付款", id: "6"},
    {label: "其它", id: "7"}
];

/**
 * 提单类型
 */
export const LADING_TYPE = () => [
    {label: "正本", id: "1"},
    {label: "SWB", id: "2"},
    {label: "电放", id: "3"},
    {label: "异地放单", id: "4"},
    {label: "铁路运单COPY", id: "6"},
    {label: "公路运单", id: "7"}
];

/**
 * 货币类型
 */
export const CURRENCY_UNIT = () =>
    [
        {label: "USD", id: "1"},
        {label: "EURO", id: "2"},
        {label: "RMB", id: "3"}
    ];
export const CURRENCY_UNIT_LIST = [
    {label: "USD", id: "USD"},
    {label: "EURO", id: "EURO"},
    {label: "RMB", id: "RMB"}
];


export enum PACKING_LIST_PARENT {
    factory_loading_plan = "factory-loading-plan",
    delivery_note = "delivery-note"
}

export const QUOTED_STATUS = [
    {name: "查看无报价产品", id: false, value: false},
    {name: "查看有报价产品", id: true, value: true}
];

export const INVOICE_STATUS =
    [
        {name: "全部", id: 1, value: 1},
        {name: "有交易单据", id: 0, value: 0},
        {name: "已完成交易", id: 2, value: 2}
    ];

export const INTERNATIONAL_TRADE_LIST =
    [
        {name: "FOB", id: "1", value: "1"},
        {name: "CIF", id: "2", value: "2"},
        {name: "C&F", id: "3", value: "3"},
        {name: "DPU", id: "4", value: "4"}
    ];


export const INVOICE_RE_STATUS = [
    {name: "待核销", value: "PENDING"},
    {name: "部分核销", value: "PART"},
    {name: "已核销", value: "COMPLETED"}
];

export const INVOICE_TYPE = [
    {name: "手工发票", value: "SHOU_GONG"},
    {name: "退税发票", value: "TUI_SHUI"},
    {name: "内销发票", value: "NEI_XIAO"}
];

    export const INVOICE_AL_STATUS = [
    {name: "未分配", value: "NONE"},
    {name: "部分分配", value: "PART"},
    {name: "完全分配", value: "ALL"},
];
